var ajax_cart_current_product_adjustment_id = "",
    ajax_cart_current_product_adjustment_qty = -1;

function setAjaxAdjust(id,qty)
{
  ajax_cart_current_product_adjustment_id = id;
  ajax_cart_current_product_adjustment_qty = qty;
}

function checkAjaxAdjust()
{
  if (ajax_cart_current_product_adjustment_qty == -1)
    return;

  newqty = $("input.ajaxcart__qty-num[data-id='" + ajax_cart_current_product_adjustment_id + "']").val();

  if (newqty == ajax_cart_current_product_adjustment_qty)
  {
    alert('You have the maximum in stock in your cart.');
  }

  ajax_cart_current_product_adjustment_qty = -1;	//reset to not run again until +/- pressed again

}

function showFilter() {
  if($(window).width() > 980){
    $('.collection-filters').show();
    $('#sortDropdown').show();
  }
}

function growShrinkLogo() {
  if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
    // $('#logo img').width(231);
    $('#logo img').width(170);
    $('.header-section #identity #logo').css({'margin-top': '-26px'});
  } else {
    $('#logo img').width(300);
    $('.header-section #identity #logo').css({'margin-top': '-10px'});
  }
  if($(window).width() < 979){
    $('.header-section #identity #logo').css({'margin-top': ''});
  }
  $(window).resize(function() {
    if($(window).width() < 979){
      $('#logo img').css({ 'width' : ''});
      $('.header-section #identity #logo').css({'margin-top': ''});
    }
  })
}


// HEADER FIXED
$(window).scroll(function(){
  if ($(window).scrollTop() >=1) {
    $('#shopify-section-header').addClass('fixed-header');
    $('#shopify-section-header').addClass('isStuck');
  }
  else {
    $('#shopify-section-header').removeClass('fixed-header');
    $('#shopify-section-header').removeClass('isStuck');
  }

  growShrinkLogo();
});


$(document).ready(function(){

  // Creates container the same height as navigation to ensure smoother scroll when the navigation position is changed to fixed
  var h = $('#shopify-section-header').height();
  $('#shopify-section-header').wrap( "<div class='header_holder'></div>" );
  $('.header_holder').height(h);

  if (window.location.href.indexOf("/apps/sitemap") > -1) {
    $('body').addClass('rs-sitemap');
  }

  // Adds Tops subnav in navigation
  // Clothing
//   #accordion .accordion-content .accordion-content2 li
  $('li.dropdown.has_sub_menu:nth-of-type(2) ul.mega-stack li, #accordion .accordion-content:nth-of-type(1) .accordion-content2 li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
          '<ul class="list_subnav">' +
          '<a href="/collections/tanks"><li>Tanks</li></a>' +
          '<a href="/collections/tunics"><li>Tunics</li></a>' +
          '<a href="/collections/blouses"><li>Blouses</li></a>' +
          '</ul>'
      );
    }
  });
  // Plus Size
  // $('li.dropdown.has_sub_menu:nth-of-type(3) ul.mega-stack li, #accordion .accordion-content:nth-of-type(2) .accordion-content2 li').each(function(){
  // $('li.dropdown.has_sub_menu:nth-of-type(3) li h4, #accordion .accordion-content:nth-of-type(2) .accordion-content2 li').each(function(){
  $('li.dropdown.has_sub_menu:nth-of-type(3) ul.mega-stack li, #accordion .accordion-content:nth-of-type(2) .accordion-content2 li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
          '<ul class="list_subnav">' +
          '<a href="/collections/plus-size-tanks"><li>Tanks</li></a>' +
          '<a href="/collections/plus-size-tunics"><li>Tunics</li></a>' +
          '<a href="/collections/plus-size-blouses"><li>Blouses</li></a>' +
          '</ul>'
      );
    }
  });

  $('#accordion .accordion-content:nth-of-type(2) .sub').html($('#accordion .accordion-content:nth-of-type(2) .accordion-content2 .sub').html());
  // Sales
  $('li.dropdown.has_sub_menu:nth-of-type(5) .mega-container li.desktop-4:nth-of-type(1) li, #accordion .accordion-content:nth-of-type(3) .accordion-content2:nth-of-type(2) li').each(function(){
    if($(this).text() == 'Tops'){
      $(this).append(
          '<ul class="list_subnav">' +
          '<a href="/collections/tanks-sale"><li>Tanks</li></a>' +
          '<a href="/collections/tunics-sale"><li>Tunics</li></a>' +
          '<a href="/collections/blouses-sale"><li>Blouses</li></a>' +
          '</ul>'
      );
    }
  });
  // Plus Size Sales
//   $('li.dropdown.has_sub_menu:nth-of-type(5) .mega-container li.desktop-4:nth-of-type(2) li, #accordion .accordion-content:nth-of-type(3) .accordion-content2:nth-of-type(4) li').each(function(){
//     if($(this).text() == 'Tops'){
//       $(this).append(
//         '<ul class="list_subnav">' +
//         '<a href="/collections/plus-size-tanks-sale"><li>Tanks</li></a>' +
//         '<a href="/collections/plus-size-tunics-sale"><li>Tunics</li></a>' +
//         '<a href="/collections/plus-size-blouses-sale"><li>Blouses</li></a>' +
//         '</ul>'
//       );
//     }
//   });

  // Remove click through on "Shop the Collection"
  $('li.dropdown.has_sub_menu:nth-of-type(2) li.desktop-6.tablet-fourth:nth-of-type(2) h4 a').attr("href", "javascript:void(0);");




  if($('body').hasClass('collection')){
    // Filter popup
    $('.filter-mobile').on('click',function(){
      $('.collection-filters, .bg-overlay').toggle();
    });
    showFilter();
  }



  if($('body').hasClass('product')){
    setTimeout(function(){
      // Remove Compelete the Look until hashed out post-launch
      $('limespot, limespot-container, limespot-box').remove();
      // Change position of Limespot - Complete The Look
      $('limespot, limespot-container, limespot-box').addClass('moved');
      $('.nosto_element').before($("limespot.moved"));
      $('.nosto_element').before($("limespot-container.moved"));
      $('.nosto_element').before($("limespot-box.moved"));
    }, 500);


    // Get saved data from PLP on localStorage
    if (localStorage.getItem("coll_handle") !== null) {       
      var coll_handle = localStorage.getItem('coll_handle').replace(/-/g, ' ');
      var coll_handle_link = localStorage.getItem('coll_handle');
    }

    // Adjust the breadcrumb text and link to reference the previous collection the user was redirected from
    if (localStorage.getItem("coll_handle") !== null) {
      $('.pdp_coll_handle').text(coll_handle);
      $('.pdp_coll_handle').parent().attr('href', 'https://www.mingwangknits.com/collections/'+ coll_handle_link)
      $('.pdp_coll_handle').parent().attr({
        href:'https://www.mingwangknits.com/collections/'+ coll_handle_link,
        id:'https://www.mingwangknits.com/collections/'+ coll_handle_link
      });
    }
  }


});



// Show filter when resizing browser from mobile
$(window).resize(function() {
  if($('body').hasClass('collection')){
    showFilter();
  }

  //To ensure smooth scrolling when header is set to position fixed
  var headerHeight = $('#shopify-section-header').height();
  $('.header_holder').height(headerHeight);
});


// Page Fade In
$( window ).on( "load", function() {
  $('#content, .index-sections, .scrollup, #shopify-section-footer').addClass('revealed');

  //Change position of Wish list button on PDP
  setTimeout(function(){
    if($('body').hasClass('product')){
      $(".swym-wishlist-button-bar").prependTo("#product-description .desc ");
      $(".swym-wishlist-button-bar").addClass('fadeIn');
    }
  }, 2500);

  setTimeout(function(){
    if($('body').hasClass('product-gift')){
      $(".swym-button-bar").css({"display": "none"});
      $(".swym-button-bar").remove();
    }
  }, 100);
});

  // loop through array in a function that generates HTML and then spit it out
  function renderProductList(product) {
    return '<li><div data-id="' + product.variants[0].id + '" class="product-index ' + product.tags.reduce(function(accumulator, v, i) { accumulator = accumulator + " " + v.replace(" ", "_").toLowerCase(); return accumulator; }, "") + ' " data-alpha="'
              + product.title + '" data-price="' + product.price + '" style="display: block; clear: right;">\
        <div class="prod-container" data-gtm-product="">\
          	<a href="/products/' + product.handle + '" title="' + product.title + '">\
                ' + (
                      (product.images.length > 0)
                        ?
                          "<img class='img " + (product.images.length > 1 ? 'first' : '') + "' data-src='" + fetchImgRendition(product.images[0], '301x') + "' alt='" + product.title + "' src='" + fetchImgRendition(product.images[0], '301x') + "'>"
                        :
                          "<img src='//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif' />") + '\
                ' + ((0 && product.images[1]) ? "<div class='hidden'><img class='second' data-src='" + fetchImgRendition(product.images[1], '301x') + "' alt='" + product.title + "' src='" + fetchImgRendition(product.images[1], '301x') + "'></div>" : "") + '\
          	</a>\
            <div class="product-info">\
              <a href="/products/' + product.handle + '">\
                <p class="h3">' + product.title + '</p>\
              </a>\
              <div class="price">'
                + (
                  (product.price < product.compare_at_price)
                    ?
                      '<div class="was">$' + parseInt((product.compare_at_price)/100).toLocaleString(undefined, {minimumFractionDigits: 2}) + '</div>\
                       <div class="onsale">$' + parseInt((product.price)/100).toLocaleString(undefined, {minimumFractionDigits: 2}) + '</div>' + '<span class="discPer">(' + (Math.round((product.compare_at_price-product.price)/product.compare_at_price*100)) +'% OFF)</span>'
                    :
                      (
                        (product.varies)
                          ?
                            '<div class="prod-price">'+'From $' + parseInt((product.price_min)/100).toLocaleString(undefined, {minimumFractionDigits: 2}) + ' - $' + parseInt((product.price_max)/100).toLocaleString(undefined, {minimumFractionDigits: 2}) + '</div>'
                          :
                            '<div class="prod-price">$' + parseInt((product.price)/100).toLocaleString(undefined, {minimumFractionDigits: 2}) + '</div>'
                      )
                ) + '\
              </div>\
            </div>\
        </div>\
  </div></li>';
  }

  function fetchImgRendition (imgUrl, size) {
    if(imgUrl) {
      var urlParts = imgUrl.split('/');
      var imgParts = urlParts.length ? urlParts[urlParts.length - 1].split('.') : '';
      if (imgParts[imgParts.length - 2]) imgParts[imgParts.length - 2] = imgParts[imgParts.length - 2] + '_' + size;
      urlParts[urlParts.length - 1] = imgParts.join('.');
      return urlParts.join('/');
    }
    return false;
  }
